import {
    SET_USER_DATA,
  } from "../types";

  import { setUserExpiry } from "../../common";
  
  const initialState = {
    allUserData: [],
  };
  
  // handle actions
  export default function (state = initialState, action) {
    const { type, payload } = action;
  
    switch (type) {
      case SET_USER_DATA: {
          //console.log( payload );
          setUserExpiry('user_data_expire');

          let isAdmin = false;

          if ( payload.roles ) {
            if ( typeof payload.roles === 'object' ) {
              if ( Object.values(payload.roles).includes("administrator") ) {

                isAdmin = true;

              }
            } else if ( payload.roles.includes('administrator') ) {

              isAdmin = true;

            } else {
              isAdmin = false;
            }

            if ( Array.isArray( payload.roles ) ) {

              if ( ! payload.roles.includes('administrator') ) {
                isAdmin = false;
              }
            }

          }

        return {
          ...state,
          allUserData: payload,
          isAdmin: isAdmin,
        };
      }
      default:
        return state;
    }
  }
  